export default {
  EventName: {
    Delete: 'Xóa',
    View: 'Xem',
    Save: 'Cất',
    SaveAdd: 'Cất và thêm mới',
    SaveClose: 'Cất và đóng',
    SaveView: 'Cất và xem',
    Edit: 'Sửa',
    Duplicate: 'Nhân bản',
    Add: 'Thêm mới',
    Active: 'Theo dõi',
    Unactive: 'Ngừng theo dõi',
    Posted: 'Ghi sổ',
    UnPosted: 'Bỏ ghi sổ',
    Ok: 'In báo cáo',
    Postpone: 'Hoãn',
    NextVoucher: 'Trước',
    BackVoucher: 'Sau',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
    Copy: 'Sao chép chứng từ',
    Import: 'Nhập khẩu', // NHANH3 27.07.2023
    NextStep: 'Tiếp tục',
    BackStep: 'Quay lại',
    SendApproval: 'Gửi duyệt',
    InsertRowGrid: 'Thêm dòng',
    DeleteRowGrid: 'Xóa dòng',
    Estimate: 'Nhập dự toán',
    Approve: 'Duyệt',
    Reject: 'Từ chối',
    SysRole: 'Phân quyền',
    SendNotify: 'Gửi thông báo cho khách hàng',
    SendInvoice: 'Gửi HĐ cho người mua',
    PublishInvoice: 'Phát hành HĐ',
    CreateSaleVoucher: 'Lập chứng từ bán hàng',
    ConvertToPaperVoucher: 'Chuyển thành HĐ giấy',
    DownloadInvoice: 'Tải HĐ',
    CancelInvoice: 'Hủy hóa đơn',
    SaleInvoiceReplace: 'Lập hóa đơn thay thế',
    CreateAdjustSaleInvoice: 'Lập hóa đơn điều chỉnh',
    PayTax: 'Nộp thuế',
    AddAutoBusiness: 'Cất thành định khoản tự động',
    SettingAccount: 'Thiết lập công thức báo cáo',

    GLVoucherDetail: 'Hạch toán chi phí lương',
    GetReceipt: 'Lấy biên lai',
    UpdateTaxIntoSalary: 'Cập nhật vào bảng lương',
    SalaryAllocation: 'Phân bổ nguồn',
    InvolveVoucher: 'Chứng từ liên quan',
    PayRollAllocation: 'Phân bổ nguồn',
    RecalculationSalary: 'Tính lại lương',
    SalaryTemplateManage: 'Quản lý mẫu',

    GenerateBaDeposit: 'Sinh chứng từ thu tiền gửi',
    GenerateCAReceipt: 'Sinh phiếu thu',
    GenerateGLVoucher: 'Sinh chứng từ nghiệp vụ khác',
    GenerateReceiptFixedAsset: 'Sinh phiếu thu bán tài sản cố định',
    GenerateInvoiceFixedAsset: 'Sinh hóa đơn bán tài sản cố định',

    CAPaymentFixedAsset: 'Thêm chứng từ Mua TSCĐ bẳng tiền mặt',
    BAWithDrawFixedAsset: 'Thêm chứng từ Mua TSCĐ bẳng tiền gửi',
    BUTransferFixedAsset: 'Thêm chứng từ Mua TSCĐ qua chuyển khoản kho bạc',
    FAPurchaseInvoice: 'Thêm chứng từ Mua TSCĐ chưa thanh toán',
    CAReceiptFixedAsset: 'Thêm chứng từ Bán tài sản cố định thu tiền mặt',
    BADepositFixedAsset: 'Thêm chứng từ Bán tài sản cố định thu tiền gửi',
    Voucher: 'Thêm chứng từ Chứng từ nghiệp vụ khác',
    ProvisionalTaxInCome: 'Thêm chứng từ Tạm tính thuế TNDN',
    FinalTaxInComeEnterprise: 'Thêm chứng từ Quyết toán thuế TNDN',
    BATransferWithdraw: 'Thêm chứng từ Tiền chuyển đi',
    BATransferDeposit: 'Thêm chứng từ Tiền chuyển đến',
    CAPaymentPurchase: 'Phiếu chi mua VTHH',
    BAWithdrawPurchase: 'Chi tiền gửi mua VTHH',
    BUTransferPurchase: 'Chuyển khoản kho bạc mua VTHH',
    CAPaymentVendor: 'Phiếu chi trả nhà cung cấp',
    BAWithdrawVendor: 'Chi tiền gửi trả nhà cung cấp',
    BUTransferVendorPayment: 'Chuyển khoản kho bạc trả nhà cung cấp',
    BUVoucherListPlanned: 'Thêm bảng kê Đã cấp dự toán',
    BUVoucherListNotPlanned: 'Thêm bảng kê Chưa cấp dự toán',
    BUVoucherListReceipExpense: 'Thêm bảng kê Ghi thu - ghi chi',
    BUVoucherListRealExpense: 'Thêm bảng kê Thực chi',
    BUVoucherListOther: 'Thêm bảng kê Khác',

    BUPlanWithdrawCash: 'Lập giấy rút dự toán Rút dự toán tiền mặt',

    ShopwCAReceiptCusomterCash: 'Chuyển khoản Thu tiền mặt',
    ShopwCAReceiptCusomterDeposit: 'Chuyển khoản Thu tiền gửi',
    ShowCAReceiptSale: 'Chuyển khoản Thu tiền mặt',
    ShowBADepositSale: 'Chuyển khoản Thu tiền gửi',
    ShowCAReceipt: 'Sinh phiếu thu',
    ShowWithDrawCash: 'Rút dự toán tiền mặt',
    ShowWithDrawDeposit: 'Rút dự toán tiền gửi',
    ShowWithDrawTransfer: 'Rút dự toán chuyển khoản',
    ShowWithDrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    ShowTransfer: 'Sinh chứng từ Chuyển khoản KB vào TK tiền gửi',
    ShowBUTreasuryFundTransferInsurancePayment: 'Sinh chứng từ chuyển khoản thanh toán bảo hiểm',
    ShowBUTreasuryFundTransferSalary: 'Sinh chứng từ chuyển khoản trả lương',

    generateCAReceipt: 'Lập chứng từ Phiếu thu',
    generateBADeposit: 'Lập chứng từ Thu tiền gửi',
    generateGLVoucher: 'Lập chứng từ Chứng từ nghiệp vụ khác',

    OutwardFromINAdjustment: 'Lập phiếu xuất kho',
    InwardFromINAdjustment: 'Lập phiếu nhập kho',

    ViewAccount: 'Xem số dư tài khoản',
    ViewQuantity: 'Xem số lượng tồn vật tư',

    GenerateData: 'Sinh giấy rút dự toán',
    GenerateDrawSalary: 'Sinh chứng từ trả lương',
    GenerateInvoice: 'Lập hóa đơn',
    GenerateCaPaymentSalary: 'Sinh chứng từ trả lương',
    GenerateDataFundSalary: 'Hạch toán chi phí lương',
    GenerateDataFundInsurance: 'Hạch toán chi phí bảo hiểm',
    GenerateBUTransferDeposit: 'Sinh chứng từ chuyển khoản kho bạc vào tài khoản tiền gửi',
    GenerateCAReceiptWithdrawDetail: 'Sinh phiếu thu rút dự toán nhập quỹ',
    GenerateBUPlanWithdrawTransferDetail: 'Sinh giấy rút dự toán tiền mặt',
    GenerateBUPlanWithdrawDepositDetail: 'Sinh giấy rút dự toán tiền gửi',
    GenerateCAReceiptWithdrawDetail: 'Sinh phiếu thu rút tiền gửi NH, KB',

    ShowBAWithDraw: 'Thêm chứng từ Chi tiền gửi',
    ShowBUTransfer: 'Thêm chứng từ Chuyển khoản kho bạc',
    ShowBUTransferDeposit: 'Thêm chứng từ Chuyển khoản kho bạc vào TK tiền gửi',
    ShowCAPaymentDetail: 'Thêm chứng từ Phiếu chi',
    ShowCAPaymentDepositDetail: 'Thêm chứng từ Phiếu chi nộp tiền vào NH, KB',

    AddInventory: 'Thêm vật tư, hàng hóa',
    AddTool: 'Thêm công cụ, dụng cụ',
    ShareReportFormula: 'Chia sẻ công thức báo cáo',
    ReShareReportFormula: 'Chia sẻ tiếp công thức báo cáo được chia sẻ',
    ApplyFormula: 'Áp dụng công thức báo cáo được chia sẻ',
    IsShowSumSourceKind: 'Hiển thị dòng tổng Nguồn NSNN - Khoản',
    IsDetailbyBudgetProvidence: 'Theo dõi theo Mã dự phòng',
    EditFileDVCReject: 'Sửa hồ sơ KBNN từ chối',
    PrintC203BudgetItemTrue: 'Báo cáo mẫu C2-03/NS in có tích chọn In mỗi mục là 1 chứng từ',
    PrintC203BudgetItemFalse: 'Báo cáo mẫu C2-03/NS in không tích chọn In mỗi mục là 1 chứng từ',
    PreviewTicket: 'Xem vé điện tử',
    GetElectronicTicket: 'Lấy vé điện tử',
    ChooseApprover: 'Chọn người duyệt hồ sơ giao dịch DVC',
    IsIncludeAccountNoAraiseTrue: 'In báo cáo/Hiển thị TK không phát sinh số liệu',
    IsIncludeAccountNoAraiseFalse: 'In báo cáo/Không hiển thị TK không phát sinh số liệu',
    ConnectDVCMultiBudgetCode: 'Kết nối DVC nhiều mã QHNS',
    // Lưu trữ
    Store: 'Lưu trữ',
    // Phục hồi Lưu trữ
    RestoreStore: 'Phục hồi Lưu trữ',
    ClickButtonInHelpSettlement: 'Thực hiện chức năng tại Hướng dẫn quyết toán',
    VoucherSearch: 'Tìm kiếm chứng từ',
    PayIncomeTax: 'Nộp thuế TNCN',
    UpdateIntoSalary: 'Cập nhật vào bảng lương',
    ExportXML: 'Xuất XML',
    SendEmailReminder: 'Gửi email nhắc nợ',
    RewriteParagraph: 'Viết lại văn bản bằng MISA AVA',
    ViewNewFeature: 'Xem tính năng mới',
    SearchInfoCompany: 'Tra cứu thông tin doanh nghiệp',
    GenerateBuTransferMoneyElectric: 'Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA',
    GenerateBuTransferMoneyWater: 'Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA',
    GenerateBuTransferMoneyPhone: 'Sinh chứng từ rút dự toán chuyển khoản kho bạc từ MISA AVA',
    GenerateBuSalary: 'Sinh chứng từ rút dự toán chuyển khoản lương từ MISA AVA',
    GenerateBuInsurance: 'Sinh chứng từ rút dự toán chuyển khoản thanh toán bảo hiểm từ MISA AVA',
    GenerateBuPlanWithDraw: 'Sinh chứng từ rút dự toán chuyển khoản từ MISA AVA',
    VoiceInputInterpretation: 'Nhập liệu diễn giải bằng giọng nói',
    EditSampleS11H: 'Sửa mẫu sổ S11-H Sổ quỹ tiền mặt',
    EditSampleC23HD: 'Sửa mẫu sổ C23HD Biên bản kiểm kê vật tư, công cụ, sản phẩm, hàng hóa',
    EditSample01a: 'Sửa mẫu sổ 01a-SDKP/ĐVDT',
    EditSample01b: 'Sửa mẫu sổ 01b-SDKP/ĐVDT',
    EditSample02a: 'Sửa mẫu sổ 02a-SDKP/ĐVDT',
    EditSample02b: 'Sửa mẫu sổ 02b-SDKP/ĐVDT',
    CheckStatusCompany: 'Kiểm tra tình trạng doanh nghiệp',
    HandleVoucherDifferentFixedAssetWithQLTS: 'Xử lý chứng từ hạch toán chênh lệch TSCĐ với phần mềm QLTS',
    ViewUserInfo: 'Xem thông tin người dùng',
    ViewGuideVoucherNewYear: 'Xem hướng dẫn nhập chứng từ năm mới',
    DeleteVoucherRelationWhenDeleteVoucherRoot: 'Xóa chứng từng có liên quan khi thực hiện xóa chứng từ gốc',
    SendEmailPaySalary: 'Soạn email thông báo trả lương',
    AddDescriptionOnC30HD: 'Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho',
    AddDescriptionOnC30HDTwoParts: 'Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho (2 liên)',
    AddDescriptionOnC30HDHasTax: 'Thêm diễn giải trên mẫu C30-HD Phiếu nhập kho (có thuế)',
    ChangeCapitalPlanYear: 'Sửa năm kế hoạch vốn trên mẫu C2-05a/NS',
    SelectedStatistic: 'Chọn mã thống kê',
    ConnectBumas: 'Kết nối MISA Bumas',
    GetDictionaryFromBumas: 'Lấy danh mục từ Bumas',
    GetBumasDecision: 'Lấy quyết định giao từ Bumas',
    SendDataBumas: 'Đẩy thông tin tình hình thực hiện dự toán sang Bumas',
    EditCoverS61: 'Sửa bìa S61',
    ConvertFromOthers: 'Tải bộ chuyển đổi từ phần mềm khác',
    CreateDvcMS09: 'Lập mẫu 09',
    Restore: 'Lấy lại thiết lập mặc định',
    ConnectASP: 'Kết nối chuyên gia',
    ReportSetting: 'Tùy chọn in',
    ExportExcel: 'Xuất Excel',
    ViewNewFeature: 'Xem tính năng mới',
    CreateTaxReduction1012023QH15: 'Lập phụ lục Giảm thuế GTGT theo Nghị quyết 101/2023/QH15',
    ExportXmlTaxReduction1012023QH15: 'Xuất khẩu XML mẫu phục lục Giảm thuế GTGT theo Nghị quyết 101/2023/QH15',
    AddTAEnterpriseIncomeTax: 'Thêm mới tờ khai thuế thu nhập doanh nghiệp mẫu 04/TNDN',
    PayUnionInsurance: 'Nộp bảo hiểm, công đoàn phí',
    GenSaleVoucherFromInvoice: 'Sinh chứng từ bán hàng từ hóa đơn',
    ChangeTaxCalculationMethod: 'Thực hiện lại chọn tính thuế GTGT theo phương pháp trực tiếp',
    CoverDesign: 'Thiết kế bìa sổ',
    Print052KQTTTNCN: 'In mẫu 05-2/BK-QTT-TNCN',
    OnlyEmployeeOutside: 'Chỉ chọn cán bộ ngoài đơn vị', // Chỉ chọn cán bộ ngoài đơn vị
    IncludeEmployeeOutside: 'Bao gồm cả cán bộ ngoài đơn vị', // Bao gồm cả cán bộ ngoài đơn vị
    ExportXML04GTGT: 'Xuất XML tờ khai thuế 04-GTGT', // Lập tờ khai thuế 04-GTGT
    EmployeeOutside: 'Thêm/sửa cán bộ là cán bộ ngoài đơn vị',
    CreateVoucherWithTaxDirect: 'Lập chứng từ phát sinh theo phương pháp tính thuế trực tiếp',
  },
  ScreenName: {
    SettingPrint: 'Tùy chọn in',
    login: 'Đăng nhập',
    BUTransfer: 'Chuyển khoản kho bạc',
    fAPurchaseIncrement: 'Mua và ghi tăng TSCĐ',
    toolList: 'Chứng từ liên quan',
    backupList: 'Sao lưu dữ liệu',
    '565C0301ND112020': 'C3-01/NS: Giấy rút vốn đầu tư (Nghị định 11)',
    '404AccountantVoucher': 'Chứng từ kế toán',
    '6404bTTND99': 'Mẫu số 04b/TT: Giấy đề nghị thu hồi vốn (Nghị định 99/2021/NĐ-CP)',
    C202aND112020254: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C206NSND11202054: 'C2-06a/NS: Giấy rút dự toán ngân sách nhà nước bằng ngoại tệ (Nghị định 11/2020/NĐ-CP)',
    C20HD2Copy158: 'C30-HD: Phiếu nhập kho (2 liên)',
    278: 'C41-BB: Phiếu chi (Giấy cuộn - A5)',
    '159VietinBank': 'Lệnh chi (Vietinbank)',
    '654AccountantVoucher': 'Chứng từ kế toán',
    225: 'C40-BB: Phiếu thu (nhiều dòng)',
    1132: 'C41-BB: Phiếu chi (2 liên - Mẫu Tiểu mục)',
    '151AccountantVoucher': 'Chứng từ kế toán',
    '413AccountantVoucher': 'Chứng từ kế toán',
    C41BBBudgetSubItem: 'C41-BB: Phiếu chi (Mẫu Tiểu mục)',
    b31df407b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (ACB) (Excel)',
    '159UNCVietinBankA51Lien': 'Ủy nhiệm chi (Vietinbank) A5 - 1 liên',
    '159UNCVIBBankA5': 'Ủy nhiệm chi (VIB bank) A5 - 1 liên',
    C202bND112020411: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '157BKND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    268: 'Giấy đề nghị thanh toán tạm ứng',
    231: 'C40-BB: Phiếu thu',
    255: 'Giấy đề nghị thanh toán tạm ứng',
    254: 'C41-BB: Phiếu chi (nhiều dòng)',
    '417AccountantVoucher': 'Chứng từ kế toán',
    f7798b0bb38711ed9ad3005056b30259: 'Ủy nhiệm chi (Vietinbank) (Excel)',
    1115: 'C41-BB: Phiếu chi (nhiều dòng)',
    '15801ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    903: 'C31-HD: Phiếu xuất kho',
    421212: 'C31-HD: Phiếu xuất kho',
    C202bND11202054: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    b31df916b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Agribank) (Excel)',
    C45BB105: 'C45-BB: Biên lai thu tiền',
    CaReceipt2LienA5TSCD: 'C40-BB: Phiếu thu (2 liên A5)',
    '213AccountantVoucher': 'Chứng từ kế toán',
    '5505TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    f7798b0bb38711ed9ad3005056b30259: 'Ủy nhiệm chi (Vietinbank) (Excel)',
    '157UNCEximBank': 'Ủy nhiệm chi (EximBank)',
    '158UNCEximBank': 'Ủy nhiệm chi (EximBank)',
    '159UNCEximBank': 'Ủy nhiệm chi (EximBank)',
    '160UNCEximBank': 'Ủy nhiệm chi (EximBank)',
    '162UNCEximBank': 'Ủy nhiệm chi (EximBank)',
    '163UNCEximBank': 'Ủy nhiệm chi (EximBank)',
    '162UNCVietinBankA41Lien': 'Ủy nhiệm chi (Vietinbank) A4 - 1 liên',
    '63MS11ND11': 'Giấy đề nghị thanh toán vốn đầu tư (Nghị định 11/2020/NĐ-CP)',
    C402cND11159: 'C4-02c/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    C402aND11152: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    '423214Portrait': 'C34-HD: Phiếu giao nhận nguyên liệu, vật liệu, công cụ, dụng cụ (Mẫu dọc)',
    281: 'C41-BB: Phiếu chi',
    f7798b0bb38711ed9ad3005056b30259: 'Ủy nhiệm chi (Vietinbank) (Excel)',
    '1408ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    '15705TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    '160BIDV': 'Ủy nhiệm chi (BIDV)',
    1022: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)',
    '162UNCVietinBankA51Lien': 'Ủy nhiệm chi (Vietinbank) A5 - 1 liên',
    '162UNCVIBBankA5': 'Ủy nhiệm chi (VIB bank) A5 - 1 liên',
    C40BB2lienA4: 'C40-BB: Phiếu thu (2 liên)',
    b31df916b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Agribank) (Excel)',
    '11611ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    811: 'Chứng từ ghi tăng TSCĐ',
    f7798b0bb38711ed9ad3005056b30259: 'Ủy nhiệm chi (Vietinbank) (Excel)',
    C41BBDetailBudget: 'C41-BB: Phiếu chi (Mẫu chi tiết nghiệp vụ kế toán)',
    '56405TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    '11409ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    '56C0301ND112020': 'C3-01/NS: Giấy rút vốn đầu tư (Nghị định 11)',
    '110AccountantVoucher': 'Chứng từ kế toán',
    '412AccountantVoucher': 'Chứng từ kế toán',
    '59AccountantVoucher': 'Chứng từ kế toán',
    274: 'Hóa đơn mua hàng',
    f7798b0bb38711ed9ad3005056b30259: 'Ủy nhiệm chi (Vietinbank) (Excel)',
    b31df03bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (BIDV) (Excel)',
    '158VietinBank': 'Lệnh chi (Vietinbank)',
    '154AccountantVoucher': 'Chứng từ kế toán',
    '201AccountantVoucher': 'Chứng từ kế toán',
    '401OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    C40BBDetailBudget: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
    '562C0301ND112020': 'C3-01/NS: Giấy rút vốn đầu tư (Nghị định 11)',
    3003160: 'Ủy nhiệm chi (Agribank)',
    '56305TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    '252AccountantVoucher': 'Chứng từ kế toán',
    '10504ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    C45BB104: 'C45-BB: Biên lai thu tiền',
    '11514ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    f7798b0bb38711ed9ad3005056b30259: 'Ủy nhiệm chi (Vietinbank) (Excel)',
    16321: 'Ủy nhiệm chi (Agribank)',
    C202aND112020561: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    S02aHVoucher: 'S02a-H: Chứng từ ghi sổ',
    C40BB2lien: 'C40-BB: Phiếu thu (2 liên)',
    4694: 'Phụ lục Giảm thuế giá trị gia tăng theo nghị quyết số 43/2022/QH15',
    11204: 'C41-BB: Phiếu chi (nhiều dòng)',
    1033: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)',
    '159BIDV': 'Ủy nhiệm chi (BIDV)',
    b31df882b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (VietcomBank) (Excel)',
    '561AccountantVoucher': 'Chứng từ kế toán',
    262: 'C41-BB: Phiếu chi (2 liên A5)',
    365: 'C41-BB: Phiếu chi (nhiều dòng)',
    217: 'C40-BB: Phiếu thu (nhiều dòng)',
    4211214: 'Mẫu số 07: Phiếu xuất kho',
    b31df776b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (TechcomBank) (Excel)',
    PaymentOrderVietinbank: 'Lệnh chi (Vietinbank)',
    C402157CurrencyND11: 'C4-02b/KB: Ủy nhiệm chi ngoại tệ (Nghị định 11/2020/NĐ-CP)',
    '170f7967330742439ab76962ecfb5125': 'UNC Viettinbank thêm',
    '5601ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    C202aND112020411: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '15901ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    244: 'C40-BB: Phiếu thu (nhiều dòng)',
    C402aND11159: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    2112: 'C40-BB: Phiếu thu (Giấy cuộn - A5)',
    C45BB102: 'C45-BB: Biên lai thu tiền',
    C402aND11410: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    3003: 'Ủy nhiệm chi (Agribank)',
    '162BIDV': 'Ủy nhiệm chi (BIDV)',
    285: 'C41-BB: Phiếu chi (Giấy cuộn - A5)',
    '41001ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    b31df03bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (BIDV) (Excel)',
    '212AccountantVoucher': 'Chứng từ kế toán',
    '254AccountantVoucher': 'Chứng từ kế toán',
    3017: 'C40-BB: Phiếu thu (Giấy cuộn - A5)',
    C41BBBudgetSubItem: 'C41-BB: Phiếu chi (Mẫu Tiểu mục)',
    '56207ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    '5605TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    11302: 'C41-BB: Phiếu chi (2 liên A5)',
    C40BBDetailBudget: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
    C402cND11158: 'C4-02c/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    232: 'C40-BB: Phiếu thu (2 liên A5)',
    401211: 'C30-HD: Phiếu nhập kho',
    401: 'C30-HD: Phiếu nhập kho',
    C20HD2Copy107: 'C30-HD: Phiếu nhập kho (2 liên)',
    1072: 'C41-BB: Phiếu chi (2 liên - Mẫu Tiểu mục)',
    '157BIDVGRTM': 'Giấy rút tiền mặt (BIDV)',
    11401: 'C40-BB: Phiếu thu',
    202: 'C40-BB: Phiếu thu (2 liên A5)',
    4211: 'Mẫu số 07: Phiếu xuất kho',
    C20HD2Copy211: 'C30-HD: Phiếu nhập kho (2 liên)',
    C45BB114: 'C45-BB: Biên lai thu tiền',
    '1408ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    '403AccountantVoucher': 'Chứng từ kế toán',
    '153OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    '11409ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    16322: 'Ủy nhiệm chi (BIDV)',
    '411AccountantVoucher': 'Chứng từ kế toán',
    '55C102NSND11': 'C1-02/NS: Giấy nộp tiền vào ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '106BKND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    '9591954de7244c8a8933afffec57dfcb': 'Test 2',
    C21HD2Copy214: 'C31-HD: Phiếu xuất kho (2 liên)',
    SalarySheetFull: 'Bảng lương',
    '157UNCVietinBank': 'Ủy nhiệm chi (Vietinbank) A4 - 2 liên',
    '157UNCVIBBankA4': 'Ủy nhiệm chi (VIB bank) A4 - 2 liên',
    C402aND11160: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    b31df882b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (VietcomBank) (Excel)',
    C202aND11202058: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C41BBDetailBudget: 'C41-BB: Phiếu chi (Mẫu chi tiết nghiệp vụ kế toán)',
    11405: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)',
    '56505TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    261: 'C41-BB: Phiếu chi',
    '106C37CT': 'C37-HD: Giấy đề nghị thanh toán (Mẫu chi tiết từng dòng)',
    C41BBBudgetSubItem: 'C41-BB: Phiếu chi (Mẫu Tiểu mục)',
    3003159: 'Ủy nhiệm chi (Agribank)',
    4211212: 'Mẫu số 07: Phiếu xuất kho',
    C42HD106: 'C42-HD: Giấy đề nghị tạm ứng',
    C402cND11163: 'C4-02c/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    421214: 'C31-HD: Phiếu xuất kho',
    b31df776b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (TechcomBank) (Excel)',
    171: 'Chứng từ ghi tăng TSCĐ',
    C45BB156: 'C45-BB: Biên lai thu tiền',
    11406: 'C40-BB: Phiếu thu (nhiều dòng)',
    C202aND11202057: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C41BBBudgetSubItem: 'C41-BB: Phiếu chi (Mẫu Tiểu mục)',
    1092: 'C41-BB: Phiếu chi (2 liên - Mẫu Tiểu mục)',
    '69AccountantVoucher': 'Chứng từ kế toán',
    '160UNCVietinBankA41Lien': 'Ủy nhiệm chi (Vietinbank) A4 - 1 liên',
    TAPL01KHBS: 'Tờ khai bổ sung 01/KHBS',
    '54MS11ND11': 'Giấy đề nghị thanh toán vốn đầu tư (Nghị định 11/2020/NĐ-CP)',
    BKNTND112020113: '01/BKNT_Bảng kê nộp thuế (Nghị định 11/2020/NĐ-CP)',
    '41001ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    C402114CurrencyND11: 'C4-02b/KB: Ủy nhiệm chi ngoại tệ (Nghị định 11/2020/NĐ-CP)',
    RetroactiveFull: 'Bảng lương truy lĩnh',
    366: 'C41-BB: Phiếu chi (2 liên A5)',
    C202bND112020153: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '113DepositOrderAgribank': 'Giấy nộp tiền vào ngân hàng Agribank',
    '157C205NSND11': 'C2-05a/NS: Giấy nộp trả kinh phí (Nghị định 11/2020/NĐ-CP)',
    '56207ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    b31df916b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Agribank) (Excel)',
    '420AccountantVoucher': 'Chứng từ kế toán',
    '157BKND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    '405AccountantVoucher': 'Chứng từ kế toán',
    b31df407b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (ACB) (Excel)',
    C302ND1163: 'C3-02/NS: Giấy đề nghị thanh toán vốn đầu tư (Nghị định 11/2020/NĐ-CP)',
    C203ND1163: 'C2-03/NS: Giấy đề nghị thanh toán tạm ứng (Nghị định 11/2020/NĐ-CP)',
    '160UNCVietinBankA51Lien': 'Ủy nhiệm chi (Vietinbank) A5 - 1 liên',
    '160UNCVIBBankA5': 'Ủy nhiệm chi (VIB bank) A5 - 1 liên',
    1572: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)',
    C45BB153: 'C45-BB: Biên lai thu tiền',
    '253AccountantVoucher': 'Chứng từ kế toán',
    2312: 'C40-BB: Phiếu thu (Giấy cuộn - A5)',
    '157BIDV': 'Ủy nhiệm chi (BIDV)',
    368: 'C41-BB: Phiếu chi (Giấy cuộn - A5)',
    '152OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    C21HD2Copy202: 'C31-HD: Phiếu xuất kho (2 liên)',
    C202aND112020563: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '10505TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    1091: 'C41-BB: Phiếu chi (2 liên)',
    C202bND112020562: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    ListSale35164: 'Bảng kê hàng hóa, dịch vụ',
    PersonalIncomeTaxDetail: 'Bảng tổng hợp thu nhập',
    403: 'C30-HD: Phiếu nhập kho (Có thuế)',
    C40BBDetailBudget: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
    161: 'C30-HD: Phiếu nhập kho',
    '11711ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    b31df776b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (TechcomBank) (Excel)',
    245: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)',
    '11514ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    '120d7bc000ae4593b34640b3d009929f': 'Vietinbank',
    631: 'C55-HD: Bảng tính hao mòn tài sản cố định',
    '162AccountantVoucher': 'Chứng từ kế toán',
    '401AccountantVoucher': 'Chứng từ kế toán',
    '351AccountantVoucher': 'Chứng từ kế toán',
    276: 'C41-BB: Phiếu chi (nhiều dòng)',
    '157VCB': 'Ủy nhiệm chi (Vietcombank)',
    '170f7967330742439ab76962ecfb5125': 'UNC Viettinbank thêm',
    1042: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)',
    b31df03bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (BIDV) (Excel)',
    301: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)',
    C202aND11202054: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '214AccountantVoucher': 'Chứng từ kế toán',
    442: 'C31-HD: Phiếu xuất kho',
    C20HD2Copy201: 'C30-HD: Phiếu nhập kho (2 liên)',
    C37BA563: 'C37-HD: Giấy đề nghị thanh toán',
    C41BBBudgetSubItem: 'C41-BB: Phiếu chi (Mẫu Tiểu mục)',
    C40BBDetailBudget: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
    '15801ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    164: 'C30-HD: Phiếu nhập kho (Có thuế)',
    '4061ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    C40BBBudgetSubItemTSCD: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)',
    '159UNCVietinBank': 'Ủy nhiệm chi (Vietinbank) A4 - 2 liên',
    '159UNCVIBBankA4': 'Ủy nhiệm chi (VIB bank) A4 - 2 liên',
    C408TT19113: 'C4-08/KB: Giấy nộp tiền vào tài khoản (Thông tư 19/2020/TT-BTC)',
    '203AccountantVoucher': 'Chứng từ kế toán',
    '565OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    '155AccountantVoucher': 'Chứng từ kế toán',
    1064: 'C37-HD: Giấy đề nghị thanh toán',
    C40BB2lienA4: 'C40-BB: Phiếu thu (2 liên)',
    C203ND1164: 'C2-03/NS: Giấy đề nghị thanh toán tạm ứng (Nghị định 11/2020/NĐ-CP)',
    C21HD2Copy204: 'C31-HD: Phiếu xuất kho (2 liên)',
    '401C37CT': 'C37-HD: Giấy đề nghị thanh toán (Mẫu chi tiết từng dòng)',
    '255AccountantVoucher': 'Chứng từ kế toán',
    C402cND11157: 'C4-02c/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    C202bND112020254: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '105OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    CashPaymentC41BB2lienA5: 'C41-BB: Phiếu chi (2 liên A5)',
    '160VietinBank': 'Lệnh chi (Vietinbank)',
    1082: 'C41-BB: Phiếu chi (2 liên - Mẫu Tiểu mục)',
    '106AccountantVoucher': 'Chứng từ kế toán',
    b31df776b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (TechcomBank) (Excel)',
    '11711ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    '170f7967330742439ab76962ecfb5125': 'UNC Viettinbank thêm',
    C21HD2Copy154: 'C31-HD: Phiếu xuất kho (2 liên)',
    b31df407b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (ACB) (Excel)',
    C37BA562: 'C37-HD: Giấy đề nghị thanh toán',
    C41BBDetailBudget: 'C41-BB: Phiếu chi (Mẫu chi tiết nghiệp vụ kế toán)',
    '564OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    C45BB154: 'C45-BB: Biên lai thu tiền',
    C40BB2lienA4: 'C40-BB: Phiếu thu (2 liên)',
    C37BA54: 'C37-HD: Giấy đề nghị thanh toán',
    601: 'Chứng từ ghi tăng TSCĐ',
    C202bND112020410: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    ListSale15464: 'Bảng kê hàng hóa, dịch vụ',
    '160AccountantVoucher': 'Chứng từ kế toán',
    1081: 'C41-BB: Phiếu chi (2 liên)',
    C41BBDetailBudgetTSCD: 'C41-BB: Phiếu chi (Mẫu chi tiết nghiệp vụ kế toán)',
    C20HD2Copy301: 'C30-HD: Phiếu nhập kho (2 liên)',
    '113C102NSND11': 'C1-02/NS: Giấy nộp tiền vào ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C202bND112020561: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    d142b52d72be44bfbcb810af8bccf673: 'Test 1',
    '158Agribank': 'Ủy nhiệm chi (Agribank)',
    C202bND112020565: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C202aND112020153: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C210NSGeneralVoucherTT19Detail: 'C2-10/NS: Phiếu điều chỉnh số liệu ngân sách (Mẫu nội dung chi tiết)',
    201: 'C40-BB: Phiếu thu',
    '6304bTTND99': 'Mẫu số 04b/TT: Giấy đề nghị thu hồi vốn (Nghị định 99/2021/NĐ-CP)',
    '64MS11ND11': 'Giấy đề nghị thanh toán vốn đầu tư (Nghị định 11/2020/NĐ-CP)',
    423212: 'C34-HD: Phiếu giao nhận nguyên liệu, vật liệu, công cụ, dụng cụ (Mẫu ngang)',
    C210NSRealExpenseAdjustmentTT19: 'C2-10/NS: Phiếu điều chỉnh số liệu ngân sách (Thông tư số 19/2020/TT-BTC)',
    C210NSRealExpenseAdjustmentTT19Detail: 'C2-10/NS: Phiếu điều chỉnh số liệu ngân sách (Mẫu nội dung chi tiết)',
    C202bND11202056: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '10504ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    C402aND11101: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    '6001ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    C202bND11202058: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    241: 'C40-BB: Phiếu thu',
    271: 'C41-BB: Phiếu chi',
    C21HD2Copy212: 'C31-HD: Phiếu xuất kho (2 liên)',
    C202aND11202056: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '11611ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    '408AccountantVoucher': 'Chứng từ kế toán',
    1062: 'C41-BB: Phiếu chi (2 liên - Mẫu Tiểu mục)',
    '423Portrait': 'C34-HD: Phiếu giao nhận nguyên liệu, vật liệu, công cụ, dụng cụ (Mẫu dọc)',
    C20HD2Copy204: 'C30-HD: Phiếu nhập kho (2 liên)',
    1101: 'C37-HD: Giấy đề nghị thanh toán',
    341: 'Chứng từ chuyển tiền',
    C402cND11160: 'C4-02c/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    C45BB103: 'C45-BB: Biên lai thu tiền',
    '415AccountantVoucher': 'Chứng từ kế toán',
    '159VCB': 'Ủy nhiệm chi (Vietcombank)',
    162: 'Hóa đơn mua hàng',
    1131: 'C41-BB: Phiếu chi (2 liên)',
    '416AccountantVoucher': 'Chứng từ kế toán',
    '5604aTTND99': 'Mẫu số 04.a/TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
    '6304aTTND99': 'Mẫu số 04.a/TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
    '421AccountantVoucher': 'Chứng từ kế toán',
    273: 'Chứng từ ghi tăng TSCĐ',
    '160VCB': 'Ủy nhiệm chi (Vietcombank)',
    C212ND112020: 'C2-12/NS: Giấy đề nghị cam kết chi NSNN  (Nghị định 11/2020/NĐ-CP)',
    277: 'Giấy đề nghị thanh toán tạm ứng',
    '104AccountantVoucher': 'Chứng từ kế toán',
    172: 'Hóa đơn mua hàng',
    '163AccountantVoucher': 'Chứng từ kế toán',
    C202aND112020565: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    212: 'C40-BB: Phiếu thu (2 liên A5)',
    b31df03bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (BIDV) (Excel)',
    S02aHPostedVoucher: 'Chứng từ ghi sổ',
    '153AccountantVoucher': 'Chứng từ kế toán',
    '109AccountantVoucher': 'Chứng từ kế toán',
    '564AccountantVoucher': 'Chứng từ kế toán',
    1531: 'C41-BB: Phiếu chi (2 liên)',
    '51AccountantVoucher': 'Chứng từ kế toán',
    '5601ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    C402aND11157: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    C37BA565: 'C37-HD: Giấy đề nghị thanh toán',
    '410AccountantVoucher': 'Chứng từ kế toán',
    C41BBDetailBudget: 'C41-BB: Phiếu chi (Mẫu chi tiết nghiệp vụ kế toán)',
    C40BB2lienA4: 'C40-BB: Phiếu thu (2 liên)',
    '162UNCVietinBank': 'Ủy nhiệm chi (Vietinbank) A4 - 2 liên',
    '162UNCVIBBankA4': 'Ủy nhiệm chi (VIB bank) A4 - 2 liên',
    1071: 'C41-BB: Phiếu chi (2 liên)',
    b31df882b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (VietcomBank) (Excel)',
    b31df03bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (BIDV) (Excel)',
    812: 'Hóa đơn mua hàng',
    C37BA55: 'C37-HD: Giấy đề nghị thanh toán',
    '16201ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    1012: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)',
    1142: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)',
    C206NSND11202055: 'C2-06a/NS: Giấy rút dự toán ngân sách nhà nước bằng ngoại tệ (Nghị định 11/2020/NĐ-CP)',
    305: 'C40-BB: Phiếu thu',
    '4061ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    b31df45bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Eximbank) (Excel)',
    C402cND11152: 'C4-02c/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    C41BBDetailBudget: 'C41-BB: Phiếu chi (Mẫu chi tiết nghiệp vụ kế toán)',
    '211AccountantVoucher': 'Chứng từ kế toán',
    C40BBDetailBudget: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
    '58AccountantVoucher': 'Chứng từ kế toán',
    '66ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    1052: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)',
    '14737ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    b31df45bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Eximbank) (Excel)',
    SalaryMS09: 'Mẫu số 09: Bảng thanh toán cho đối tượng thụ hưởng (Công văn 4123/KBNN-KSC)',
    SalarySheetTT107C02HD:
      'C02-HD: Bảng lương thanh toán tiền lương và các khoản phụ cấp theo lương, các khoản nộp theo lương',
    1104: 'C41-BB: Phiếu chi (2 liên A5)',
    CT011KHBS: '01-1/KHBS: Phụ lục bản giải trình khai bổ sung',
    b31df45bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Eximbank) (Excel)',
    '158UNCVietinBankA41Lien': 'Ủy nhiệm chi (Vietinbank) A4 - 1 liên',
    '105AccountantVoucher': 'Chứng từ kế toán',
    '56401ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    267: 'C30-HD: Phiếu nhập kho (Có thuế)',
    284: 'C41-BB: Phiếu chi (nhiều dòng)',
    1532: 'C41-BB: Phiếu chi (2 liên - Mẫu Tiểu mục)',
    C202aND11202055: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    219: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)',
    '162VietinBank': 'Lệnh chi (VietinBank)',
    2212: 'C40-BB: Phiếu thu (Giấy cuộn - A5)',
    C202aND11202060: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    b31df45bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Eximbank) (Excel)',
    1105: 'C41-BB: Phiếu chi (nhiều dòng)',
    '423212Portrait': 'C34-HD: Phiếu giao nhận nguyên liệu, vật liệu, công cụ, dụng cụ (Mẫu dọc)',
    C40BBDetailBudget: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
    '158UNCVietinBankA51Lien': 'Ủy nhiệm chi (Vietinbank) A5 - 1 liên',
    '158UNCVIBBankA5': 'Ủy nhiệm chi (VIB bank) A5 - 1 liên',
    b31df45bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Eximbank) (Excel)',
    '163UNCVietinBank': 'Ủy nhiệm chi (Vietinbank) A4 - 2 liên',
    '163UNCVIBBankA4': 'Ủy nhiệm chi (VIB bank) A4 - 2 liên',
    403211: 'C30-HD: Phiếu nhập kho (Có thuế)',
    '56401ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    C213ND112020ST: 'C2-13/NS: Giấy điều chỉnh cam kết chi NSNN  (Nghị định 11/2020/NĐ-CP)',
    1063: 'C37-HD: Giấy đề nghị thanh toán',
    '158AccountantVoucher': 'Chứng từ kế toán',
    '114AccountantVoucher': 'Chứng từ kế toán',
    '564C0301ND112020': 'C3-01/NS: Giấy rút vốn đầu tư (Nghị định 11)',
    b31df45bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Eximbank) (Excel)',
    '101AccountantVoucher': 'Chứng từ kế toán',
    '56AccountantVoucher': 'Chứng từ kế toán',
    1108: 'Giấy đề nghị thanh toán tạm ứng',
    C408TT19153: 'C4-08/KB: Giấy nộp tiền vào tài khoản (Thông tư 19/2020/TT-BTC)',
    264: 'Hóa đơn mua hàng',
    '5405TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    C21HD2Copy351: 'C31-HD: Phiếu xuất kho (2 liên)',
    '402AccountantVoucher': 'Chứng từ kế toán',
    '652C210NSTT19': 'C2-10/NS: Phiếu điều chỉnh số liệu ngân sách (Thông tư số 19/2020/TT-BTC)',
    '7004aTTND99': 'Mẫu số 04.a/TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
    351: 'Chứng từ chuyển tiền',
    C402152CurrencyND11: 'C4-02b/KB: Ủy nhiệm chi ngoại tệ (Nghị định 11/2020/NĐ-CP)',
    '56101ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    BKNTND112020157: '01/BKNT_Bảng kê nộp thuế (Nghị định 11/2020/NĐ-CP)',
    '157OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    '56501ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    '419AccountantVoucher': 'Chứng từ kế toán',
    ListSale70164: 'Bảng kê hàng hóa, dịch vụ',
    283: 'C41-BB: Phiếu chi (2 liên A5)',
    C210NSGeneralVoucherTT19: 'C2-10/NS: Phiếu điều chỉnh số liệu ngân sách (Thông tư số 19/2020/TT-BTC)',
    '56101ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    313: 'C30-HD: Phiếu nhập kho',
    403213: 'C30-HD: Phiếu nhập kho (Có thuế)',
    C45BB155: 'C45-BB: Biên lai thu tiền',
    '106OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    b31df882b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (VietcomBank) (Excel)',
    '11515ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    C41BBDetailBudget: 'C41-BB: Phiếu chi (Mẫu chi tiết nghiệp vụ kế toán)',
    '157C102NSND11': 'C1-02/NS: Giấy nộp tiền vào ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '157AccountantVoucher': 'Chứng từ kế toán',
    C402aND11161: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    C202aND112020410: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    236: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)',
    '6404aTTND99': 'Mẫu số 04.a/TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
    '113C205NSND11': 'C2-05a/NS: Giấy nộp trả kinh phí (Nghị định 11/2020/NĐ-CP)',
    '565AccountantVoucher': 'Chứng từ kế toán',
    '5504aTTND99': 'Mẫu số 04.a/TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
    C202bND112020564: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    b31df03bb0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (BIDV) (Excel)',
    1061: 'C41-BB: Phiếu chi (2 liên)',
    2541: 'Đánh giá lại tài sản cố định',
    '162VCB': 'Ủy nhiệm chi (Vietcombank)',
    11306: 'C41-BB: Phiếu chi (Giấy cuộn - A5)',
    SalarySheetFullC13HD: 'Bảng lương mẫu C13HD',
    b31df882b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (VietcomBank) (Excel)',
    11301: 'C41-BB: Phiếu chi',
    C402aND11163: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    '102AccountantVoucher': 'Chứng từ kế toán',
    '114BIDVGRTM': 'Giấy rút tiền mặt (BIDV)',
    '170f7967330742439ab76962ecfb5125': 'UNC Viettinbank thêm',
    C202bND11202055: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '162OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    '158BIDV': 'Ủy nhiệm chi (BIDV)',
    C40BB2lienA4: 'C40-BB: Phiếu thu (2 liên)',
    C202bND112020105: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    16324: 'Lệnh chi (Vietinbank)',
    '60AccountantVoucher': 'Chứng từ kế toán',
    '170f7967330742439ab76962ecfb5125': 'UNC Viettinbank thêm',
    '202AccountantVoucher': 'Chứng từ kế toán',
    '106BKND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    802: 'Hóa đơn mua hàng',
    C37BA157: 'C37-HD: Giấy đề nghị thanh toán',
    '57AccountantVoucher': 'Chứng từ kế toán',
    '09aff0a275304387a9e0774ede38844e': 'BIDV',
    '156AccountantVoucher': 'Chứng từ kế toán',
    431: 'Phiếu chuyển kho',
    314: 'Hóa đơn mua hàng',
    b31df776b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (TechcomBank) (Excel)',
    '6001ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    307: 'C40-BB: Phiếu thu (2 liên A5)',
    '11515ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    C402162CurrencyND11: 'C4-02b/KB: Ủy nhiệm chi ngoại tệ (Nghị định 11/2020/NĐ-CP)',
    '101OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    266: 'C41-BB: Phiếu chi (nhiều dòng)',
    C37BA60: 'C37-HD: Giấy đề nghị thanh toán',
    '52AccountantVoucher': 'Chứng từ kế toán',
    C41HD106: 'C41-HD: Bảng kê đề nghị thanh toán',
    '01a59876b2be493e8c51cec27583497b': 'Mẫu trộn 1',
    C37BA564: 'C37-HD: Giấy đề nghị thanh toán',
    '157UNCVietinBankA41Lien': 'Ủy nhiệm chi (Vietinbank) A4 - 1 liên',
    C402cND11162: 'C4-02c/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    1103: 'C41-BB: Phiếu chi',
    '5404aTTND99': 'Mẫu số 04.a/TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
    306: 'C40-BB: Phiếu thu (nhiều dòng)',
    421: 'C31-HD: Phiếu xuất kho',
    242: 'C40-BB: Phiếu thu (2 liên A5)',
    2412: 'C40-BB: Phiếu thu (Giấy cuộn - A5)',
    252: 'C41-BB: Phiếu chi (2 liên A5)',
    '561OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    211: 'C40-BB: Phiếu thu',
    '55MS11ND11': 'Giấy đề nghị thanh toán vốn đầu tư (Nghị định 11/2020/NĐ-CP)',
    C202bND11202060: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    234: 'C40-BB: Phiếu thu (nhiều dòng)',
    '56C102NSND11': 'C1-02/NS: Giấy nộp tiền vào ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C302ND1164: 'C3-02/NS: Giấy đề nghị thanh toán vốn đầu tư (Nghị định 11/2020/NĐ-CP)',
    221: 'C40-BB: Phiếu thu',
    '352AccountantVoucher': 'Chứng từ kế toán',
    801: 'C30-HD: Phiếu nhập kho',
    '151OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    C41BBBudgetSubItemTSCD: 'C41-BB: Phiếu chi (Mẫu Tiểu mục)',
    256: 'C41-BB: Phiếu chi (Giấy cuộn - A5)',
    C45BB101: 'C45-BB: Biên lai thu tiền',
    804: 'C30-HD: Phiếu nhập kho (Có thuế)',
    251: 'C41-BB: Phiếu chi',
    b31df916b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Agribank) (Excel)',
    1107: 'C41-BB: Phiếu chi (2 liên)',
    '105C0301ND112020': 'C3-01/NS: Giấy rút vốn đầu tư (Nghị định 11)',
    '159AccountantVoucher': 'Chứng từ kế toán',
    C402aND11158: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    263: 'C30-HD: Phiếu nhập kho',
    372: 'C31-HD: Phiếu xuất kho',
    '56501ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    C408TT19561: 'C4-08/KB: Giấy nộp tiền vào tài khoản (Thông tư 19/2020/TT-BTC)',
    364: 'C41-BB: Phiếu chi',
    '152AccountantVoucher': 'Chứng từ kế toán',
    '53AccountantVoucher': 'Chứng từ kế toán',
    11412: 'C40-BB: Phiếu thu (Giấy cuộn - A5)',
    '159UNCVietinBankA41Lien': 'Ủy nhiệm chi (Vietinbank) A4 - 1 liên',
    401213: 'C30-HD: Phiếu nhập kho',
    441: 'C30-HD: Phiếu nhập kho',
    C202aND112020101: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '55C0301ND112020': 'C3-01/NS: Giấy rút vốn đầu tư (Nghị định 11)',
    '113OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    C202aND112020562: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '107AccountantVoucher': 'Chứng từ kế toán',
    323: 'Chứng từ ghi tăng TSCĐ',
    '66ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    BKNTND112020106: '01/BKNT_Bảng kê nộp thuế (Nghị định 11/2020/NĐ-CP)',
    '114OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    '170f7967330742439ab76962ecfb5125': 'UNC Viettinbank thêm',
    '158VCB': 'Ủy nhiệm chi (Vietcombank)',
    '70MS11ND11': 'Giấy đề nghị thanh toán vốn đầu tư (Nghị định 11/2020/NĐ-CP)',
    C202aND112020105: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    205: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)',
    '113AccountantVoucher': 'Chứng từ kế toán',
    214: 'C31-HD: Phiếu xuất kho',
    11012: 'C41-BB: Phiếu chi (Giấy cuộn - A5)',
    b31df916b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Agribank) (Excel)',
    '103AccountantVoucher': 'Chứng từ kế toán',
    204: 'C40-BB: Phiếu thu (nhiều dòng)',
    '1309ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    '1309ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    '160UNCVietinBank': 'Ủy nhiệm chi (Vietinbank) A4 - 2 liên',
    '160UNCVIBBankA4': 'Ủy nhiệm chi (VIB bank) A4 - 2 liên',
    1109: 'C41-BB: Phiếu chi (2 liên - Mẫu Tiểu mục)',
    11307: 'C41-BB: Phiếu chi (nhiều dòng)',
    BKNTND11202056: '01/BKNT_Bảng kê nộp thuế (Nghị định 11/2020/NĐ-CP)',
    16323: 'Ủy nhiệm chi (Vietcombank)',
    C402aND11114: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
    C202bND11202057: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C37BA56: 'C37-HD: Giấy đề nghị thanh toán',
    C217aNS192020TTBTC: 'C2-17a/NS: Lệnh ghi thu, ghi chi ngân sách (Thông tư số 19/2020/TT-BTC)',
    '163UNCVietinBankA41Lien': 'Ủy nhiệm chi (Vietinbank) A4 - 1 liên',
    315: 'C30-HD: Phiếu nhập kho (Có thuế)',
    '54C0301ND112020': 'C3-01/NS: Giấy rút vốn đầu tư (Nghị định 11)',
    C40BB2lienA4: 'C40-BB: Phiếu thu (2 liên)',
    3003162: 'Ủy nhiệm chi (Agribank)',
    '56OriginalCurrency': 'Chứng từ kế toán (Mẫu nguyên tệ)',
    324: 'Hóa đơn mua hàng',
    f903f5275e7b45c3aa7b42677e60c9f2: 'mẫu test3',
    269: 'C41-BB: Phiếu chi (Giấy cuộn - A5)',
    C40BBDetailBudgetTSCD: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
    '158UNCVietinBank': 'Ủy nhiệm chi (Vietinbank) A4 - 2 liên',
    '158UNCVIBBankA4': 'Ủy nhiệm chi (VIB bank) A4 - 2 liên',
    b31df776b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (TechcomBank) (Excel)',
    b31df407b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (ACB) (Excel)',
    '251AccountantVoucher': 'Chứng từ kế toán',
    406: 'S01B: Bảng tổng hợp chứng từ',
    '157UNCVietinBankA51Lien': 'Ủy nhiệm chi (Vietinbank) A5 - 1 liên',
    '157UNCVIBBankA5': 'Ủy nhiệm chi (VIB bank) A5 - 1 liên',
    '301AccountantVoucher': 'Chứng từ kế toán',
    '14737ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    11402: 'C40-BB: Phiếu thu (2 liên A5)',
    2012: 'C40-BB: Phiếu thu (Giấy cuộn - A5)',
    C20HD2Copy57: 'C30-HD: Phiếu nhập kho (2 liên)',
    b31df407b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (ACB) (Excel)',
    '163UNCVietinBankA51Lien': 'Ủy nhiệm chi (Vietinbank) A5 - 1 liên',
    '163UNCVIBBankA5': 'Ủy nhiệm chi (VIB bank) A5 - 1 liên',
    '108AccountantVoucher': 'Chứng từ kế toán',
    C21HD2Copy102: 'C31-HD: Phiếu xuất kho (2 liên)',
    '563C0301ND112020': 'C3-01/NS: Giấy rút vốn đầu tư (Nghị định 11)',
    C20HD2Copy213: 'C30-HD: Phiếu nhập kho (2 liên)',
    423214: 'C34-HD: Phiếu giao nhận nguyên liệu, vật liệu, công cụ, dụng cụ (Mẫu ngang)',
    423: 'C34-HD: Phiếu giao nhận nguyên liệu, vật liệu, công cụ, dụng cụ (Mẫu ngang)',
    '56205TTND99': 'Mẫu số 05/TT: Giấy rút vốn (Nghị định 99/2021/NĐ-CP)',
    C202bND112020101: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    C41BBBudgetSubItem: 'C41-BB: Phiếu chi (Mẫu Tiểu mục)',
    b31df882b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (VietcomBank) (Excel)',
    C202bND112020563: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    ListSale10264: 'Bảng kê hàng hóa, dịch vụ',
    b31df916b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (Agribank) (Excel)',
    '15901ND112020': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
    C202aND112020564: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
    '414AccountantVoucher': 'Chứng từ kế toán',
    b31df407b0ce11ed9ad3005056b30259: 'Ủy nhiệm chi (ACB) (Excel)',
    '16201ND112020Portrait': 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
    C402101CurrencyND11: 'C4-02b/KB: Ủy nhiệm chi ngoại tệ (Nghị định 11/2020/NĐ-CP)',
    UNCVPbankA42Lien: 'Ủy nhiệm chi (VPbank) A4 - 2 liên',
    UNCVPbankA51Lien: 'Ủy nhiệm chi (VPbank) A5 - 1 liên',
    BUPlanWithdrawCashDetail: 'Rút dự toán tiền mặt',
    BUPlanWithdrawDepositDetail: 'Rút dự toán tiền gửi',
    BUPlanWithdrawTransferDetail: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawSalaryTransferDetail: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    SAElectronicTicketDetail: 'Vé điện tử',
    KKTM: 'Bảng kiểm kê tiền mặt trong quỹ',
    SampleC30HD: 'C30-HD: Phiếu nhập kho',
    SampleC30HDTwoParts: 'C30-HD: Phiếu nhập kho (2 liên)',
    SampleC30HDHasTax: 'C30-HD: Phiếu nhập kho (Có thuế)',
  },
  BrowserTitle: {
    page_Login: 'Đăng nhập',
    page_gettingstarted: 'Bắt đầu sử dụng',

    // Tab KHO BẠC
    tab_treasury_process: 'Quy trình __ Kho bạc',
    tab_treasury_buplanreceipt: 'Nhận dự toán',
    tab_treasury_budgetplan: 'Rút dự toán',
    tab_treasury_transfer: 'Chuyển khoản kho bạc',
    tab_treasury_buvoucherlist: 'Bảng kê chứng từ thanh toán',
    tab_treasury_careceiptplanwithdrawlist: 'Nhập quỹ tiền mặt',
    tab_treasury_buplanwdadjustment: 'Điều chỉnh kinh phí',
    tab_treasury_buplanadjustment: 'Điều chỉnh dự toán',
    tab_treasury_bucommitment: 'Cam kết chi',
    tab_treasury_bubudgetreserve: 'Dự toán giữ lại',
    tab_treasury_buplanimport: 'Nhập dự toán',
    tab_treasury_buplancancel: 'Hủy dự toán',
    tab_treasury_appendix: 'Đối chiếu với kho bạc',

    // Tab KHO BẠC ĐIỆN TỬ
    tab_etreasury_process: 'Quy trình __ Kho bạc điện tử',
    tab_etreasury_dvcfile: 'Hồ sơ giao dịch',
    tab_etreasury_dcsdfile: 'Quản lý hồ sơ đối chiếu số dư',

    // tab TIỀN MẶT
    tab_cash_process: 'Quy trình __ Tiền mặt',
    tab_cash_careceipt: 'Phiếu thu',
    tab_cash_capayment: 'Phiếu chi',
    tab_cash_cafundinventory: 'Kiểm kê',

    // tab TIỀN GỬI
    tab_deposits_process: 'Quy trình __ Tiền gửi',
    tab_deposits_badeposit: 'Thu tiền gửi',
    tab_deposits_bawithdraw: 'Chi tiền gửi',
    tab_deposits_babanktransfer: 'Chuyển tiền nội bộ',

    // tab KHO
    tab_inventory_process: 'Quy trình __ Kho',
    tab_inventory_ininward: 'Nhập kho',
    tab_inventory_inoutward: 'Xuất kho',
    tab_inventory_intransfer: 'Chuyển kho',
    tab_inventory_inadjustment: 'Điều chỉnh tồn kho',

    // tab CÔNG CỤ DỤNG CỤ
    tab_tools_process: 'Quy trình __ Công cụ dụng cụ',
    tab_tools_suincrement: 'Ghi tăng CCDC',
    tab_tools_sutransfer: 'Điều chuyển CCDC',
    tab_tools_sudecrement: 'Ghi giảm CCDC',

    // tab TÀI SẢN CỐ ĐỊNH
    tab_asset_process: 'Quy trình __ Tài sản cố định',
    tab_asset_fapurchaseincrement: 'Mua và ghi tăng',
    tab_asset_faincrement: 'Nhận bằng hiện vật và ghi tăng',
    tab_asset_fatransfer: 'Điều chuyển',
    tab_asset_faadjustment: 'Đánh giá lại',
    tab_asset_fadevaluation: 'Trích khấu hao',
    tab_asset_fadepreciation: 'Tính hao mòn',
    tab_asset_fadecrement: 'Ghi giảm',
    tab_asset_farevenue: 'Doanh thu',

    tab_assetqlts_list: 'Tài sản cố định',

    // tab MUA HÀNG
    tab_purchase_process: 'Quy trình __ Mua hàng',
    tab_purchase_pupayment: 'Mua hàng trả tiền ngay',
    tab_purchase_puinvoice: 'Mua hàng chưa thanh toán',
    tab_purchase_puvendorpayment: 'Trả tiền nhà cung cấp',
    tab_purchase_invoicebot: 'Xử lý hóa đơn đầu vào',

    // tab TIỀN LƯƠNG
    tab_salary_processsalagov: 'Quy trình __ Tiền lương',
    tab_salary_process: 'Quy trình __ Tiền lương',
    tab_salary_statisticaldayoff: 'Bảng tổng hợp ngày nghỉ/làm thêm, làm đêm',
    tab_salary_otherincome: 'Thu nhập không thường xuyên',
    tab_salary_paotheroutcome: 'Khấu trừ không thường xuyên',
    tab_salary_PARetroSalary: 'Bảng lương truy lĩnh',
    tab_salary_pasalary: 'Bảng lương',
    tab_salary_glpayrollexpensesalarylist: 'Hạch toán chi phí lương',
    tab_salary_papersonalincometax: 'Bảng tính thuế',

    // tab BÁN HÀNG
    tab_sell_process: 'Quy trình __ Bán hàng',
    tab_sell_careceiptsale: 'Bán hàng thu tiền ngay',
    tab_sell_sainvoice: 'Bán hàng chưa thu tiền',
    tab_sell_careceiptcustomer: 'Thu tiền khách hàng',
    tab_sell_sareturn: 'Hàng bán trả lại',

    // tab HÓA ĐƠN
    tab_invoice_process: 'Quy trình __ Hóa đơn',
    tab_invoice_meInvoiceConnect: 'Kết nối phần mềm HĐĐT',
    tab_invoice_meInvoiceConnected: 'Bắt đầu sử dụng HĐĐT',
    tab_invoice_saleinvoice: 'Hóa đơn',
    tab_invoice_cancelInvoice: 'Hủy hóa đơn',
    tab_invoice_receipt: 'Biên lai',
    tab_invoice_electronicTicket: 'Vé điện tử',

    // tab THUẾ
    tab_tax_process: 'Quy trình __ Thuế',
    tab_tax_tacircularvat: 'Tờ khai thuế giá trị gia tăng',
    tab_tax_riskcustomervendor: 'Danh sách NCC có rủi ro',
    tab_enterprise_income_tax: 'Tờ khai thuế thu nhập doanh nghiệp',

    // tab TỔNG HỢP
    tab_summary_process: 'Quy trình __ Tổng hợp',
    tab_summary_glvoucher: 'Chứng từ nghiệp vụ khác',
    tab_summary_glpostedvoucher: 'Chứng từ ghi sổ',
    tab_summary_vouchersummarytable: 'Bảng TH chứng từ cùng loại',
    tab_summary_glprofitlosstransfer: 'Xác định kết quả hoạt động',
    tab_summary_endyeartransfer: 'Kết chuyển số dư cuối năm',
    tab_summary_beginningyeartransfer: 'Quyết toán số dư đầu năm',
    tab_summary_crereplist: 'Báo cáo tài chính',
    tab_summary_crerepsettlementtab: 'Báo cáo quyết toán',
    tab_summary_crerepexportlisttab: 'Nộp báo cáo cho kho bạc',
    tab_summary_crerepexportlisttaxtab: 'Nộp báo cáo cho cơ quan thuế',
    tab_summary_cRERepReportSubmit: 'Nộp báo cáo lên cấp trên',

    // tab BÁO CÁO
    tab_report_list: 'Báo cáo',

    // tab DANH MỤC
    tab_dictionary_list: 'Danh mục',

    // tab DANH MỤC / TÀI KHOẢN
    tab_dictionary_account_systemaccount: 'Hệ thống tài khoản',
    tab_dictionary_account_accounttransfer: 'Tài khoản kết chuyển',
    tab_dictionary_account_defaultaccount: 'Tài khoản ngầm định',
    tab_dictionary_account_autobusiness: 'Định khoản tự động',

    // tab DANH MỤC / MỤC LỤC NGÂN SÁCH
    tab_dictionary_budget_budgetchapter: 'Chương',
    tab_dictionary_budget_budgetkinditem: 'Loại - khoản',
    tab_dictionary_budget_budgetitem: 'Mục - Tiểu mục',
    tab_dictionary_budget_budgetsource: 'Nguồn kinh phí',
    tab_dictionary_budget_budgesourceproperty: 'Tính chất nguồn kinh phí',
    tab_dictionary_budget_project: 'Chương trình mục tiêu, dự án',
    tab_dictionary_budget_budgetprovide: 'Mã dự phòng',

    // tab DANH MỤC / NGÂN HÀNG
    tab_dictionary_bank_typeoffund: 'Loại quỹ',
    tab_dictionary_bank_currency: 'Loại tiền',
    tab_dictionary_bank_bankinfocategory: 'Loại tài khoản tiền gửi kho bạc',
    tab_dictionary_bank_bankinfo: 'Tài khoản Ngân hàng, Kho bạc',

    // tab DANH MỤC / ĐỐI TƯỢNG
    tab_dictionary_object_accountingobjectcategory: 'Loại khách hàng, nhà cung cấp',
    tab_dictionary_object_customervendor: 'Khách hàng, nhà cung cấp',
    tab_dictionary_object_employee: 'Cán bộ',
    tab_dictionary_object_department: 'Phòng ban',

    // tab DANH MỤC / LƯƠNG CÁN BỘ
    tab_dictionary_staffsalary_employeetype: 'Loại cán bộ',
    tab_dictionary_staffsalary_payrollitem: 'Khoản lương',
    tab_dictionary_staffsalary_salaryscale: 'Ngạch lương',
    tab_dictionary_staffsalary_pAOption: 'Quy định lương, thuế TNCN, bảo hiểm',

    // tab DANH MỤC / KHO
    tab_dictionary_inventory_tooltype: 'Loại công cụ dụng cụ',
    tab_dictionary_inventory_toollist: 'Công cụ dụng cụ',
    tab_dictionary_inventory_inventorycategory: 'Loại Vật tư, Hàng hóa',
    tab_dictionary_inventory_inventoryitem: 'Vật tư, Hàng hóa',
    tab_dictionary_inventory_stock: 'Kho',

    // tab DANH MỤC / TÀI SẢN
    tab_dictionary_asset_fixedassetcategory: 'Loại tài sản cố định',
    tab_dictionary_asset_fixedasset: 'Tài sản cố định',

    // tab DANH MỤC / THUẾ
    tab_dictionary_tax_purchasepurpose: 'Nhóm hàng hóa, dịch vụ mua vào',
    tab_dictionary_tax_invoiceformnumber: 'Mẫu số hóa đơn',

    // tab DANH MỤC / KHÁC
    tab_dictionary_other_vouchertype: 'Loại chứng từ',
    tab_dictionary_other_budgetFees: 'Phí, lệ phí',
    tab_dictionary_other_task: 'Nhiệm vụ',
    tab_dictionary_other_activity: 'Hoạt động',
    tab_dictionary_other_fundstructure: 'Cơ cấu vốn',
    tab_dictionary_other_statistic: 'Mã thống kê',
    tab_dictionary_other_budgetgroupitem: 'Nhóm mục chi',
    tab_dictionary_other_topic: 'Đề tài',
    tab_dictionary_other_contract: 'Hợp đồng',

    // tab SỐ DƯ BAN ĐẦU
    tab_accountBalance_opaccountbalance: 'Số dư tài khoản',
    tab_accountBalance_opbankaccountbalance: 'Số dư tài khoản ngân hàng',
    tab_accountBalance_opcustomerbalance: 'Công nợ khách hàng',
    tab_accountBalance_opsupplierbalance: 'Công nợ nhà cung cấp',
    tab_accountBalance_opemployeebalance: 'Công nợ cán bộ',
    tab_accountBalance_opinventorybalance: 'Tồn kho vật tư hàng hóa',

    // tab CCDC BAN ĐẦU
    tab_openingTool_openingSupplyEntry: 'Nhập công cụ dụng cụ ban đầu',

    // tab TỔNG QUAN
    tab_dashboard: 'Tổng quan',

    popup_setting_accountParallel: 'Thiết lập quy tắc hạch toán đồng thời',

    // ---------- Các popup detail. Lưu ý các key bắt đầu bằng detail_ phải có mã thì mới show tiêu đề --------------
    detail_popup_buplanreceiptdetail: 'Nhận dự toán',

    detail_popup_buplanwithdrawcashdetail: 'Rút dự toán tiền mặt',
    detail_popup_buplanwithdrawdepositdetail: 'Rút dự toán tiền gửi',
    detail_popup_buplanwithdrawtransferdetail: 'Rút dự toán chuyển khoản',
    detail_popup_buplanwithdrawsalarytransferdetail: 'Rút dự toán chuyển khoản lương, bảo hiểm',

    detail_popup_butransferdetail: 'Chuyển khoản kho bạc',
    detail_popup_butransferdepositdetail: 'Chuyển khoản kho bạc vào TK tiền gửi',

    detail_popup_buvoucherlistplanneddetail: 'Bảng kê chứng từ thanh toán đã cấp dự toán',
    detail_popup_buvoucherlistnotplanneddetail: 'Bảng kê chứng từ thanh toán chưa cấp dự toán',
    detail_popup_buvoucherlistreceipexpensedetail: 'Bảng kê chứng từ thanh toán ghi thu - ghi chi',
    detail_popup_buvoucherlistrealexpensedetail: 'Bảng kê chứng từ thanh toán thực chi',
    detail_popup_buvoucherlistotherdetail: 'Bảng kê chứng từ khác',

    // tiền mặt/phiếu thu --- khi bạc/nhập quỹ tiền mặt
    detail_popup_careceiptplanwithdrawdetail: 'Phiếu thu rút dự toán nhập quỹ',

    detail_popup_buexpensewithdrawadjustmentdetail: 'Điều chỉnh tạm ứng',
    detail_popup_burealexpenseadjustmentdetail: 'Điều chỉnh thực chi',

    detail_popup_buplanadjustmentdetail: 'Điều chỉnh dự toán',

    detail_popup_bucommitmentrequestdetail: 'Đề nghị cam kết chi',

    detail_popup_bubudgetreservedetail: 'Dự toán giữ lại',

    detail_popup_BUPlanImportDetail: 'Nhập dự toán',

    detail_popup_buplancanceldetail: 'Hủy dự toán',

    detail_popup_careceiptdetail: 'Phiếu thu',
    detail_popup_careceiptwithdrawdetail: 'Phiếu thu rút tiền gửi ngân hàng, kho bạc',
    detail_popup_capaymentdetail: 'Phiếu chi',
    detail_popup_capaymentdepositdetail: 'Phiếu chi nộp tiền vào ngân hàng, kho bạc',
    detail_popup_cafundinventorydetail: 'Bảng kiểm kê quỹ',

    detail_popup_badepositdetail: 'Thu tiền gửi',
    detail_popup_bawithdrawdetail: 'Chi tiền gửi',

    detail_popup_babanktransferdetail: 'Chuyển tiền nội bộ',

    detail_popup_pupaymentdetail: 'Mua hàng trả tiền ngay',
    detail_popup_puinvoicedetail: 'Mua hàng chưa thanh toán',
    detail_popup_ininwarddetail: 'Nhập kho',

    detail_popup_inoutwarddetail: 'Xuất kho',
    detail_popup_intransferdetail: 'Chuyển kho',
    detail_popup_inadjustmentdetail: 'Điều chỉnh tồn kho',

    detail_popup_suincrementdetail: 'Ghi tăng CCDC',
    detail_popup_sutransferdetail: 'Điều chuyển CCDC',
    detail_popup_sudecrementdetail: 'Ghi giảm CCDC',

    detail_popup_favoucherincreament: 'Chọn tài sản ghi tăng từ MISA QLTS',
    detail_popup_favoucherdecrement: 'Chọn tài sản ghi giảm từ MISA QLTS',
    detail_popup_favoucheradjustment: 'Chọn tài sản đánh giá lại từ MISA QLTS',
    detail_popup_favoucherdepreciate: 'Chọn tài sản trích khấu hao từ MISA QLTS',
    detail_popup_favoucherdepreciation: 'Chọn tài sản tính hao mòn từ MISA QLTS',

    detail_popup_favoucherincreamentdetail: 'Ghi tăng TSCĐ từ MISA QLTS',
    detail_popup_favoucherdecrementdetail: 'Ghi giảm TSCĐ từ MISA QLTS',
    detail_popup_favoucheradjustmentdetail: 'Đánh giá lại TSCĐ từ MISA QLTS',
    detail_popup_favoucherdepreciatedetail: 'Khấu hao TSCĐ từ MISA QLTS',
    detail_popup_favoucherdepreciationdetail: 'Hao mòn TSCĐ từ MISA QLTS',

    detail_popup_fapurchaseincrementdetail: 'Mua TSCĐ trả tiền ngay',
    detail_popup_fainvoicefixedassetdetail: 'Mua TSCĐ chưa thanh toán',
    detail_popup_faincrementdetail: 'Nhận bằng hiện vật và ghi tăng',
    detail_popup_fatransferdetail: 'Điều chuyển tài sản cố định',
    detail_popup_faadjustmentdetail: 'Đánh giá lại tài sản cố định',
    detail_popup_fadevaluationdetail: 'Trích khấu hao tài sản cố định',
    detail_popup_fadepreciationdetail: 'Tính hao mòn tài sản cố định',
    detail_popup_fadecrementdetail: 'Ghi giảm tài sản cố định',
    detail_popup_careceiptfixedassetdetail: 'Chứng từ bán tài sản cố định thu tiền ngay',
    detail_popup_fasaleinvoicedetail: 'Bán tài sản cố định chưa thu tiền',

    detail_popup_statisticaldayoffdetail: 'Bảng tổng hợp ngày nghỉ/làm thêm, làm đêm',
    detail_popup_paotherincomedetail: 'Thu nhập không thường xuyên',
    detail_popup_paotheroutcomedetail: 'Khấu trừ không thường xuyên',
    detail_popup_paretrosalaryincreasedetail: ' ',
    detail_popup_paretrostandardsalaryincreasedetail: ' ',
    detail_popup_pasalarydetail: ' ',

    detail_popup_glpayrollexpensedetail: 'Hạch toán chi phí lương',
    detail_popup_papersonalincometaxdetail: ' ',
    detail_popup_puvendorpaymentdetail: 'Trả tiền nhà cung cấp',

    detail_popup_careceiptsaledetail: 'Chứng từ bán hàng thu tiền ngay',
    detail_popup_sainvoicedetail: 'Chứng từ bán hàng',
    detail_popup_careceiptcustomerdetail: 'Thu tiền khách hàng',
    detail_popup_sareturndetail: 'Hàng bán trả lại',
    detail_popup_adjustsasaleinvoicedetail: 'Hóa đơn điều chỉnh',

    detail_popup_sasaleinvoicedetail: 'Hóa đơn',
    detail_popup_tacircularvatdeclarationdetail: 'Tờ khai thuế giá trị gia tăng',
    detail_popup_taenterpriseincometaxdetail: 'Tờ khai thuế thu nhập doanh nghiệp',

    detail_popup_glgeneralvoucherdetail: 'Chứng từ nghiệp vụ khác',
    detail_popup_glprovisionaltaxincomeenterprisedetail: 'Tạm tính thuế thu nhập doanh nghiệp',
    detail_popup_glfinaltaxincomeenterprisedetail: 'Quyết toán thuế thu nhập doanh nghiệp',
    detail_popup_batransferwithdrawdetail: 'Tiền chuyển đi',
    detail_popup_batransferdepositdetail: 'Tiền chuyển đến',
    detail_popup_glpostedvoucherdetail: 'Chứng từ ghi sổ',
    detail_popup_glvouchersummarytabledetail: 'Bảng tổng hợp chứng từ cùng loại',
    detail_popup_glprofitlosstransferdetail: 'Xác định kết quả hoạt động',
    detail_popup_glendyeartransferdetail: 'Kết chuyển số dư cuối năm',
    detail_popup_glbeginningyeartransferdetail: 'Quyết toán số dư đầu năm',

    detail_popup_cRERepListDetail: 'Báo cáo tài chính',
    detail_popup_CRERepSettlementDetail: 'Báo cáo quyết toán',
    detail_popup_CRERepExportListDetail: 'Báo cáo nộp cho Kho bạc nhà nước',
    detail_popup_CRERepExportListTaxDetail: 'Báo cáo nộp cho cơ quan Thuế',

    detail_popup_opaccountbalancelistdetail: 'Nhập số dư tài khoản',
    detail_popup_OPAccountBalanceDetail: 'Nhập chi tiết số dư',
    detail_popup_opbankaccountbalancedetail: 'Nhập chi tiết số dư tài khoản ngân hàng',
    detail_popup_OPCustomerBalanceListDetail: 'Nhập số dư công nợ khách hàng',
    detail_popup_OPCustomerBalanceDetail: 'Nhập chi tiết số dư công nợ khách hàng',
    detail_popup_OPSupplierBalanceListDetail: 'Nhập số dư công nợ nhà cung cấp',
    detail_popup_OPSupplierBalanceDetail: 'Nhập chi tiết số dư công nợ nhà cung cấp',
    detail_popup_OPEmployeeBalanceListDetail: 'Nhập số dư công nợ cán bộ',
    detail_popup_OPEmployeeBalanceDetail: 'Nhập chi tiết số dư công nợ cán bộ',
    detail_popup_OPInventoryBalanceDetail: 'Nhập số dư tồn kho, vật tư hàng hóa',
    detail_popup_OpeningSupplyEntryDetail: 'Nhập công cụ dụng cụ ban đầu',

    detail_popup_ImportExcel: ' ',

    detail_tax_TADocumentPopup: ' ',

    popup_ChoseFinanceReportSetting: 'Thiết lập báo cáo tài chính',
    detail_popup_FinanceReportSetting: ' ',
    popup_customSetting: 'Thiết lập tùy chọn',
    popup_SortRefNo: 'Sắp xếp lại số chứng từ',
    popup_LockLedgerVoucher: 'Khóa sổ kỳ kế toán',
    popup_UnLockLedgerVoucher: 'Bỏ khóa sổ',
    popup_PostedVoucher: 'Ghi sổ/Bỏ ghi theo lô',
    popup_ChoseLayoutReportSetting: 'Quản lý mẫu',
    popup_ViewDebtInvoiceACTPopup: 'Xem hóa đơn tài chính MISA cấp',
    popup_SynchronousResults: 'Kết quả đồng bộ chứng từ làm việc ngoại tuyến',
    popup_LookUpBusinessInformation: 'Tra cứu thông tin doanh nghiệp',
    popup_DVCExportSubmitData: 'Kết xuất dữ liệu để kết nối đến Kho bạc Nhà nước',
    popup_DataMaintenance: 'Bảo trì dữ liệu',
    popup_ConvertTT23: 'Cập nhật thông tư 23/2023/TT-BTC',
    popup_UpdateTT76Popup: 'Cập nhật thông tư 76/2019/TT-BTC',
    popup_BackupRestore: 'Sao lưu dữ liệu kế toán',
    popup_DisplaySetting: 'Thiết lập hiển thị',
    popup_settingesignallproject: 'Thiết lập ký số',
    popup_companyinfo: 'Thông tin đơn vị',
    popup_usermanagement: 'Quản lý người dùng',
    popup_TARiskCustomerVendorDetail: 'Danh sách hóa đơn phát sinh',
    detail_popup_usermanagementdetail: ' ',

    tab_dictionary_datamanagement_dataManagement: 'Quản lý dữ liệu',
    tab_dictionary_datamanagement_backup: 'Sao lưu dữ liệu',
    tab_dictionary_datamanagement_storage: 'Lưu trữ dữ liệu',
    tab_dictionary_datamanagement_DatabaseHistory: 'Lịch sử quản lý dữ liệu',
    tab_dictionary_datamanagement_createDataPrevYear: 'Tạo mới dữ liệu từ năm trước',
    tab_dictionary_datamanagement_conversionOfAccountingSystem: 'Cập nhật TT 24/2024/TT-BTC',
    tab_dictionary_datamanagement_createData: 'Tạo mới dữ liệu',
    tab_dictionary_system_sysrole: 'Vai trò quyền hạn',
    detail_tab_dictionary_system_SystemUserRoleDetail: ' ',
    tab_dictionary_system_ConvertDownloadPoup: 'Chuyển đổi dữ liệu',
    tab_dictionary_system_CopyDataOther: 'Sao chép dữ liệu',
    tab_accessHistory: 'Nhật ký truy cập',
    tab_RestoreVoucher: 'Phục hồi chứng từ đã xóa',
    tab_connect: 'Kết nối phần mềm MISA',
    tab_report: 'Báo cáo',
    detail_tab_report: ' ',
    popup_VoucherSearch: 'Tìm kiếm chứng từ',

    popup_opaccountentryprevyeardetail: 'Lấy số dư đầu năm',
  },
};
